export default __webpack_public_path__ + "static/media/loading-gif.e80fa95c.gif";